import * as z from "zod/v4";

export const createSubscribeKeyword = {
  name: "createSubscribeKeyword" as const,
  input: z.object({
    keyword: z
      .string()
      .min(3)
      .max(20)
      .regex(/^[A-Z0-9]+$/),
    tagLegacyIds: z.array(z.string()),
  }),
  output: z.object({ id: z.string() }),
};
